<template>
	<div>
        <b-overlay :show="tsLoading" no-wrap></b-overlay>
        <form >

            <b-form-group label="Seleccione la moneda:"  description="Solo se podrán seleccionar los servicios que tengan esta moneda">
                <b-form-select
                v-model="form.currency"
                :options="currencies"
                required
                @change="tsSelected=[]"
                ></b-form-select>
            </b-form-group>
            <b-row>

                <b-col cols="12" md="5">
                    <b-form-group label="fecha vencimiento:">
                        <b-form-datepicker
                        size="sm"
                        class="mb-1"
                        locale="es"
                        v-model="form.date "
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5">
                    <b-form-group label="Hora:"  >
                        <vue-timepicker
                        required
                        manual-input
                        input-width="6em"
                        class="mb-1"
                        v-model="form.time"
                        />
                    </b-form-group>
                </b-col>
            </b-row>


			<FormGroupBox title="Servicios">
				<b-table hover :items="itemsTableTs" :fields="fieldsTs" stacked="sm" responsive="md" >
					<template #cell(checkSelected)="row">
						<md-icon
							v-b-tooltip.hover="'Este servicio esta seleccionado en otra solicitud de pago'"
							v-if="form.id==-1 && row.item.havePayments"
							:icon="'info'"
						/>
						<b-form-checkbox v-else size="lg"  v-model="tsSelected" :value="row.item.id" :disabled="!row.item.canBeChecked"></b-form-checkbox>
					</template>
					<template #cell(bookingPriceTotal)="row">
						${{row.item.bookingPriceTotal}}
					</template>
				</b-table>
			</FormGroupBox>
			<FormGroupBox title="Adicionales">
				<b-table hover :items="itemsTableAdditionalServices" :fields="fieldsAdditionServices" stacked="sm" responsive="md" >
					<template #cell(checkSelected)="row">
						<md-icon
							v-b-tooltip.hover="'Este servicio esta seleccionado en otra solicitud de pago'"
							v-if="form.id==-1 && row.item.havePayments"
							:icon="'info'"
						/>
						<b-form-checkbox v-else size="lg"  v-model="additionServicesSelected" :value="row.item.id" :disabled="!row.item.canBeChecked"></b-form-checkbox>
					</template>
					<template #cell(bookingPriceTotal)="row">
						${{row.item.bookingPriceTotal}}
					</template>
				</b-table>
			</FormGroupBox>
			<h1 v-if="totalPayment>0" class="text-right text-success">${{totalCalculatedFormatted}} {{currencySelected}}</h1>

            <div class="container">
				<div class="row justify-content-end">
					<b-button  v-if="totalPayment>0" variant="primary" @click="save">Guardar</b-button>

				</div>
			</div>
        </form>
	</div>
</template>

<script>
import api from '../../../../api.js'
import numeral from 'numeral';
import VueTimepicker from "vue2-timepicker";
import FormGroupBox from "@/components/helpers/FormGroupBox";
export default {
	components: {
		VueTimepicker,
		FormGroupBox
	},
	props: {
		modelId:{
            required:true,
            default:-1
        }
	},
	data(){
        const defaultForm= {
            id:-1,
            currency:"",
            total:0,
            status:"pending",
            date:"",
            time:"23:59",
        }
		return {
            hasErrors:false,
            form: {...defaultForm},
            tsSelected:[],
            tsLoading:false,
            listTs:[],
			fieldsTs: [
                {label:"",key:"checkSelected"},
                {label:"Numero de servicio",key:"serviceNumber"},
                {label:"Canal de venta",key:"salesChannelName"},
                {label:"Tipo viaje",key:"tripType"},
                {label:"Moneda",key:"bookingCurrency"},
                {label:"Total",key:"bookingPriceTotal"}
            ],
			additionServicesSelected:[],
            additionServicesLoading:false,
			listAdditionServices:[],
			fieldsAdditionServices: [
                {label:"",key:"checkSelected"},
                {label:"Nombre",key:"name"},
                {label:"Estado de pago",key:"paymentStatus"},
                {label:"Estado",key:"status"},
                {label:"Moneda",key:"bookingCurrency"},
                {label:"Total",key:"bookingPriceTotal"}
            ],
		}
	},
	methods: {
        getTransportServices(){
            this.tsLoading = true
            this.listTs    = [];
            api(this).get(`/reservations/${this.modelId}/payments/all-services`).then( res => {
                this.listTs = [...res.data.transportServices]
				this.listAdditionServices= [...res.data.AdditionalServices]
            })
            .catch(this.$root.handleRequestError)
            .finally(()=>{
                this.tsLoading= false;
            })
		},
        getDataForSave(){
            let data = {...this.form};
            data.total = parseFloat(this.totalCalculated) +parseFloat(this.totalCalculatedAdditionalServices);
            data.transportServicesIds = this.tsSelected
			data.additionalServicesIds = this.additionServicesSelected
            return data;
        },
        save(){
            if(this.validate()){
                this.tsLoading = true;
                api(this).post(`/reservations/${this.modelId}/payment/`,this.getDataForSave())
                .then( (res) => {
                    this.$root.showAlert("se agregó correctamente el pago #"+res.data.id)
                    this.$emit("done");
                })
                .catch(this.$root.handleRequestError)
                .finally(()=>{
                    this.tsLoading = false;
                })
            }
        },
        validate(){
			try{
				if(this.isEmpty(this.form.currency)){
					throw "Moneda es requerido";
				}
                if(this.isEmpty(this.form.time) || this.isEmpty(this.form.date)){
					throw "Fecha y hora de expiración es requerido";
				}
                if(this.tsSelected.length<=0 && this.additionServicesSelected.length<=0){
					throw "Seleccione por lo menos un servicio";
				}
                if(this.totalCalculated<=0 && this.totalCalculatedAdditionalServices<=0){
					throw "Seleccione por lo menos un servicio con total mayor a 0";
				}
			}catch(err){
				this.$root.showAlert(err,{variant:'danger'})
				return false;
			}
			return true;


		},
		isEmpty(val){
			return (val ===null || val === undefined || val==="");
		},

		reset(){
			Object.assign(this.$data, this.$options.data.apply(this))
			this.getSettingPointOfSale()
		},
        toLowercase(value){
            return value.toLowerCase();
        },
        toUppercase(value){
            return value.toUpperCase();
        }

	},
	computed:{
        currencySelected(){
            return this.toUppercase(this.form.currency)
        },
        currencies(){
			//OBTIENE LAS MONEDAS DISPONIBLES
            let currencies =[];
            this.listTs.forEach((ts)=>{
                let currencyCode = this.toLowercase(ts.bookingCurrency);
                let currencyLabel = this.toUppercase(ts.bookingCurrency);
				//CREA UN INDICE CON LA PROPIEDAD DE LA MONEDA PARA TENER UN INDICE UNICO Y ACTUALIZABLE
                currencies[currencyCode] =  { value: currencyCode, text: currencyLabel };

            });

			this.listAdditionServices.forEach((ts)=>{
                let currencyCode = this.toLowercase(ts.bookingCurrency);
                let currencyLabel = this.toUppercase(ts.bookingCurrency);
				//CREA UN INDICE CON LA PROPIEDAD DE LA MONEDA PARA TENER UN INDICE UNICO Y ACTUALIZABLE
                currencies[currencyCode] =  { value: currencyCode, text: currencyLabel };

            });
            return (Object.values(currencies));
        },
        itemsTableTs(){
            let items = [];
            this.listTs.forEach((ts)=>{
                let canBeChecked     = (this.toLowercase(ts.bookingCurrency) === this.toLowercase(this.form.currency))?true:false;
                let havePayments     = (ts.paymentStatus != "pending")
                let rowVariant       = (havePayments && this.form.id==-1)?"danger":""
                ts.havePayments      = havePayments,
                ts._rowVariant       = rowVariant
                ts.canBeChecked      = canBeChecked;
                items.push(ts)
            });
            items.sort((a)=>{
                return (a.havePayments)?-1:1;
            })
            return items;
        },
		itemsTableAdditionalServices(){
            let items = [];
            this.listAdditionServices.forEach((ts)=>{
                let canBeChecked     = (this.toLowercase(ts.bookingCurrency) === this.toLowercase(this.form.currency))?true:false;
                let havePayments     = (ts.paymentStatus != "pending")
                let rowVariant       = (havePayments && this.form.id==-1)?"danger":""
                ts.havePayments      = havePayments,
                ts._rowVariant       = rowVariant
                ts.canBeChecked      = canBeChecked;
                items.push(ts)
            });
            items.sort((a)=>{
                return (a.havePayments)?-1:1;
            })
            return items;
        },
        totalCalculated(){
			//CALCULA EL TOTAL DE TRANSPORT SERVICES
            let total = 0;
            this.tsSelected.forEach((tsId)=>{
                let found = this.listTs.find(element => (element.id === tsId ));
                total+=parseFloat(found.bookingPriceTotal??0);
            });
            return total;
        },
		totalCalculatedAdditionalServices(){
			// CALCULA EL TOTAL DE SERVICIOS ADICIONALES SELECCIONADOS
            let total = 0;
            this.additionServicesSelected.forEach((tsId)=>{
                let found = this.listAdditionServices.find(element => (element.id === tsId ));
                total+=parseFloat(found.bookingPriceTotal??0);
            });
            return total;
        },
        totalPayment(){
			let total=(parseFloat(this.totalCalculated)) + (parseFloat(this.totalCalculatedAdditionalServices));
            return total;
        },
        totalCalculatedFormatted(){
			//FORMATE LA MONEDA DE SERVICIOS ADICIONALES
            return numeral(this.totalPayment).format('0,0.[00]');
        },
	},
	watch:{

	},
	mounted(){
        this.getTransportServices();
	},

}
</script>
